import { render } from "./Youtube.vue?vue&type=template&id=30e05546&ts=true"
import script from "./Youtube.vue?vue&type=script&lang=ts"
export * from "./Youtube.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__